(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bai-bundle-buy"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bai-bundle-buy')) {
  customElements.define('bai-bundle-buy',class extends HTMLElement {
    connectedCallback() {
      this.sync = () => {
        this.builder = document.querySelector('bai-bundle');
        const source = this.builder?.querySelector('[data-bundle-submit]');
        this.querySelectorAll('[data-quick-buy]').forEach(button => {button.disabled = !source || source.disabled;});
        if (this.builder?.money) {
          this.querySelectorAll('[data-bai-gross]').forEach(el => {el.textContent = this.builder.money.format(this.builder.total / 100);});
          this.querySelectorAll('[data-bai-net]').forEach(el => {el.textContent = this.builder.money.format(Math.round(this.builder.total / 1.2) / 100);});
        }
      };
      this.buy = () => this.builder?.querySelector('[data-bundle-submit]')?.click();
      this.querySelectorAll('[data-quick-buy]').forEach(button => button.addEventListener('click',this.buy));
      document.addEventListener('bai:bundle-change',this.sync);
      this.sync();
      const sticky = this.querySelector('.bai-buy__sticky');
      const source = document.querySelector('bai-bundle');
      if (sticky && source) {
        this.intersection = new IntersectionObserver(entries => {sticky.hidden = entries[0].isIntersecting;});
        this.intersection.observe(source);
      }
    }
    disconnectedCallback() {
      document.removeEventListener('bai:bundle-change',this.sync);
      this.querySelectorAll('[data-quick-buy]').forEach(button => button.removeEventListener('click',this.buy));
      this.intersection?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bai-recommendations"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bai-product-row')){
 customElements.define('bai-product-row',class extends HTMLElement{
  connectedCallback(){
   this.track=this.querySelector('.bai-grid');this.controls=this.querySelector('.bai-row-controls');this.buttons=[...this.querySelectorAll('[data-bai-scroll]')];
   this.sync=()=>{const max=this.track.scrollWidth-this.track.clientWidth;this.controls.hidden=max<2;this.buttons[0].disabled=this.track.scrollLeft<2;this.buttons[1].disabled=this.track.scrollLeft>=max-2;};
   this.move=e=>{const card=this.track.querySelector('.bai-card');if(!card)return;const gap=parseFloat(getComputedStyle(this.track).columnGap)||0;this.track.scrollBy({left:Number(e.currentTarget.dataset.baiScroll)*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};
   this.buttons.forEach(b=>b.addEventListener('click',this.move));this.track.addEventListener('scroll',this.sync,{passive:true});this.resize=new ResizeObserver(this.sync);this.resize.observe(this.track);requestAnimationFrame(this.sync);
  }
  disconnectedCallback(){this.buttons?.forEach(b=>b.removeEventListener('click',this.move));this.track?.removeEventListener('scroll',this.sync);this.resize?.disconnect();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brother-bundle-buy"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brother-bundle-buy')) {
    customElements.define('brother-bundle-buy', class extends HTMLElement {
      connectedCallback() {
        this.builder = document.querySelector('.fm-bundle-builder');
        this.source = this.builder?.querySelector('form button[type="submit"]');
        if (!this.source) { this.hidden = true; return; }
        this.total = this.builder.querySelector('[data-total]');
        this.onBuy = () => {
          if (!this.source.disabled) this.source.click();
        };
        this.buttons = this.querySelectorAll('[data-quick-buy]');
        this.buttons.forEach(button => button.addEventListener('click', this.onBuy));
        this.sync = () => {
          const total = this.total?.textContent.replace(/^Your bundle:\s*/, '').trim();
          if (total) this.querySelectorAll('[data-buy-price]').forEach(price => { price.textContent = total; });
          this.buttons.forEach(button => {
            button.disabled = this.source.disabled;
            button.setAttribute('aria-busy', this.source.classList.contains('loading') ? 'true' : 'false');
          });
        };
        this.change = () => requestAnimationFrame(this.sync);
        document.addEventListener('change', this.change);
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.builder, {attributes:true, childList:true, subtree:true, characterData:true});
        this.sync();
        const sticky = this.querySelector('.brother-buy__sticky');
        if (sticky) {
          this.intersection = new IntersectionObserver(entries => {
            sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.bottom >= 0;
          });
          this.intersection.observe(this.source);
        }
      }
      disconnectedCallback() {
        this.buttons?.forEach(button => button.removeEventListener('click', this.onBuy));
        document.removeEventListener('change', this.change);
        this.observer?.disconnect();
        this.intersection?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brother-commercial-buy"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brother-commercial-buy')) {
    customElements.define('brother-commercial-buy', class extends HTMLElement {
      connectedCallback() {
        this.builder=document.querySelector('.fm-bundle-builder');this.source=this.builder?.querySelector('form button[type="submit"]') || document.querySelector('.product-detail__information .product-detail__buy-buttons button[name="add"]');
        if (!this.source) { this.hidden = true; return; }
        this.prices = JSON.parse(this.querySelector('[data-variant-prices]').textContent);
        this.onBuy = () => {
          if (!this.source.disabled) this.source.click();
        };
        this.buttons = this.querySelectorAll('[data-quick-buy]');
        this.buttons.forEach(button => button.addEventListener('click', this.onBuy));
        this.sync = () => {
          const variantId = this.builder?.dataset.selectedVariant || this.source.form?.querySelector('[name="id"]')?.value;
          const variant = this.prices.find(item => String(item.id) === String(variantId));
          if(variant)this.querySelectorAll('[data-buy-price]').forEach(price=>{for(const [selector,value] of [['[data-commercial-net]',variant.net],['[data-commercial-gross]',variant.price]]){const el=price.querySelector(selector);if(el&&el.textContent!==value)el.textContent=value;}});
          this.buttons.forEach(button => {
            if(button.disabled!==this.source.disabled)button.disabled=this.source.disabled;
            const busy=this.source.classList.contains('loading')?'true':'false';if(button.getAttribute('aria-busy')!==busy)button.setAttribute('aria-busy',busy);
          });
        };
        this.change = () => requestAnimationFrame(this.sync);
        document.addEventListener('change', this.change);
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.builder || this.source.closest('.product-detail__information'), {attributes:true, childList:true, subtree:true, characterData:true});
        this.sync();
        const sticky = this.querySelector('.brother-buy__sticky');
        if (sticky) {
          this.intersection = new IntersectionObserver(entries => {
            sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.bottom >= 0;
          });
          this.intersection.observe(this.source);
        }
      }
      disconnectedCallback() {
        this.buttons?.forEach(button => button.removeEventListener('click', this.onBuy));
        document.removeEventListener('change', this.change);
        this.observer?.disconnect();
        this.intersection?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brother-commercial-product"]) return;
  try {
    
if (!customElements.get('brother-commercial-pricing')) {
 customElements.define('brother-commercial-pricing',class extends HTMLElement {
  connectedCallback(){
   this.info=this.closest('.product-detail__information');
   this.variants=JSON.parse(this.querySelector('[data-commercial-variants]').textContent);
   this.sync=()=>{
    const builder=this.info.querySelector('.fm-bundle-builder');
    const id=builder?.dataset.selectedVariant || this.info.querySelector('.product-detail__buy-buttons form [name="id"]')?.value;
    const variant=this.variants.find(v=>String(v.id)===String(id));
    if(!variant)return;
    for(const [selector,value] of [['[data-commercial-net]',variant.net],['[data-commercial-gross]',variant.gross]]){const el=this.querySelector(selector);if(el&&el.textContent!==value)el.textContent=value;}
   };
   this.change=()=>requestAnimationFrame(this.sync);document.addEventListener('change',this.change);
   this.observer=new MutationObserver(this.sync);this.observer.observe(this.info,{childList:true,subtree:true,attributes:true,characterData:true});this.sync();
  }
  disconnectedCallback(){document.removeEventListener('change',this.change);this.observer?.disconnect();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brother-quick-buy"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brother-quick-buy')) {
    customElements.define('brother-quick-buy', class extends HTMLElement {
      connectedCallback() {
        this.source = document.querySelector('.product-detail__information .product-detail__buy-buttons button[name="add"]');
        if (!this.source) { this.hidden = true; return; }
        this.prices = JSON.parse(this.querySelector('[data-variant-prices]').textContent);
        this.onBuy = () => {
          if (!this.source.disabled) this.source.click();
        };
        this.buttons = this.querySelectorAll('[data-quick-buy]');
        this.buttons.forEach(button => button.addEventListener('click', this.onBuy));
        this.sync = () => {
          const variantId = this.source.form?.querySelector('[name="id"]')?.value;
          const variant = this.prices.find(item => String(item.id) === String(variantId));
          if (variant) this.querySelectorAll('[data-buy-price]').forEach(price => { price.textContent = variant.price; });
          this.buttons.forEach(button => {
            button.disabled = this.source.disabled;
            button.setAttribute('aria-busy', this.source.classList.contains('loading') ? 'true' : 'false');
          });
        };
        this.change = () => requestAnimationFrame(this.sync);
        document.addEventListener('change', this.change);
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.source.closest('.product-detail__information'), {attributes:true, childList:true, subtree:true, characterData:true});
        this.sync();
        const sticky = this.querySelector('.brother-buy__sticky');
        if (sticky) {
          this.intersection = new IntersectionObserver(entries => {
            sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.bottom >= 0;
          });
          this.intersection.observe(this.source);
        }
      }
      disconnectedCallback() {
        this.buttons?.forEach(button => button.removeEventListener('click', this.onBuy));
        document.removeEventListener('change', this.change);
        this.observer?.disconnect();
        this.intersection?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feiyue-collection"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.feiyue-shopping').forEach(section => {
 section.querySelectorAll('[data-feiyue-filter]').forEach(button => button.addEventListener('click', () => {
  const choice = button.dataset.feiyueFilter;
  section.querySelectorAll('[data-feiyue-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  section.querySelectorAll('[data-feiyue-kind]').forEach(item => { item.hidden = choice !== 'all' && item.dataset.feiyueKind !== choice; });
 }));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fm-brand-collection"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-fm-model-search]').forEach(form=>{
  form.addEventListener('submit',()=>{
    const field=form.querySelector('[name="q"]');
    const brand=form.dataset.brand.trim();
    const value=field.value.trim();
    if(brand&&value&&!value.toLowerCase().includes(brand.toLowerCase())) field.value=brand+' '+value;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poolin-bundle-buy"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('poolin-bundle-buy')) {
  customElements.define('poolin-bundle-buy',class extends HTMLElement {
    connectedCallback() {
      this.sync = () => {
        this.builder = document.querySelector('poolin-bundle');
        const source = this.builder?.querySelector('[data-bundle-submit]');
        this.querySelectorAll('[data-quick-buy]').forEach(button => {button.disabled = !source || source.disabled;});
        if (this.builder?.money) {
          this.querySelectorAll('[data-poolin-gross]').forEach(el => {el.textContent = this.builder.money.format(this.builder.total / 100);});
          this.querySelectorAll('[data-poolin-net]').forEach(el => {el.textContent = this.builder.money.format(Math.round(this.builder.total / 1.2) / 100);});
        }
      };
      this.buy = () => this.builder?.querySelector('[data-bundle-submit]')?.click();
      this.querySelectorAll('[data-quick-buy]').forEach(button => button.addEventListener('click',this.buy));
      document.addEventListener('poolin:bundle-change',this.sync);
      this.sync();
      const sticky = this.querySelector('.poolin-buy__sticky');
      const source = document.querySelector('poolin-bundle');
      if (sticky && source) {
        this.intersection = new IntersectionObserver(entries => {sticky.hidden = entries[0].isIntersecting;});
        this.intersection.observe(source);
      }
    }
    disconnectedCallback() {
      document.removeEventListener('poolin:bundle-change',this.sync);
      this.querySelectorAll('[data-quick-buy]').forEach(button => button.removeEventListener('click',this.buy));
      this.intersection?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poolin-quick-buy"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('poolin-quick-buy')) {
    customElements.define('poolin-quick-buy', class extends HTMLElement {
      connectedCallback() {
        this.source = document.querySelector('.product-detail__information .product-detail__buy-buttons button[name="add"]');
        if (!this.source) { this.hidden = true; return; }
        this.prices = JSON.parse(this.querySelector('[data-variant-prices]').textContent);
        this.onBuy = () => {
          if (!this.source.disabled) this.source.click();
        };
        this.buttons = this.querySelectorAll('[data-quick-buy]');
        this.buttons.forEach(button => button.addEventListener('click', this.onBuy));
        this.sync = () => {
          const variantId = this.source.form?.querySelector('[name="id"]')?.value;
          const variant = this.prices.find(item => String(item.id) === String(variantId));
          if (variant) this.querySelectorAll('[data-buy-price]').forEach(price => { const gross = price.querySelector('[data-poolin-gross]'); const net = price.querySelector('[data-poolin-net]'); if (gross) gross.textContent = variant.price; if (net) net.textContent = variant.ex; });
          this.buttons.forEach(button => {
            button.disabled = this.source.disabled;
            button.setAttribute('aria-busy', this.source.classList.contains('loading') ? 'true' : 'false');
          });
        };
        this.change = () => requestAnimationFrame(this.sync);
        document.addEventListener('change', this.change);
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.source.closest('.product-detail__information'), {attributes:true, childList:true, subtree:true, characterData:true});
        this.sync();
        const sticky = this.querySelector('.poolin-buy__sticky');
        if (sticky) {
          this.intersection = new IntersectionObserver(entries => {
            sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.bottom >= 0;
          });
          this.intersection.observe(this.source);
        }
      }
      disconnectedCallback() {
        this.buttons?.forEach(button => button.removeEventListener('click', this.onBuy));
        document.removeEventListener('change', this.change);
        this.observer?.disconnect();
        this.intersection?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poolin-recommendations"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('poolin-product-row')){
 customElements.define('poolin-product-row',class extends HTMLElement{
  connectedCallback(){
   this.track=this.querySelector('.poolin-grid');this.controls=this.querySelector('.poolin-row-controls');this.buttons=[...this.querySelectorAll('[data-poolin-scroll]')];
   this.sync=()=>{const max=this.track.scrollWidth-this.track.clientWidth;this.controls.hidden=max<2;this.buttons[0].disabled=this.track.scrollLeft<2;this.buttons[1].disabled=this.track.scrollLeft>=max-2;};
   this.move=e=>{const card=this.track.querySelector('.poolin-card');if(!card)return;const gap=parseFloat(getComputedStyle(this.track).columnGap)||0;this.track.scrollBy({left:Number(e.currentTarget.dataset.poolinScroll)*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};
   this.buttons.forEach(b=>b.addEventListener('click',this.move));this.track.addEventListener('scroll',this.sync,{passive:true});this.resize=new ResizeObserver(this.sync);this.resize.observe(this.track);requestAnimationFrame(this.sync);
  }
  disconnectedCallback(){this.buttons?.forEach(b=>b.removeEventListener('click',this.move));this.track?.removeEventListener('scroll',this.sync);this.resize?.disconnect();}
 });
}

  } catch(e) { console.error(e); }
})();
})();
